import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";
import { Navbar } from "../../components/navbar/Navbar";
import { Footer } from "../../components/footer/Footer";
import { getEmployee } from "../../models/employees";
import "./reservationConfirmed.css";

const ERROR_MESSAGES = {
  BAD_TOKEN:
    "Tento odkaz není platný. Zkontroluj prosím, že jsi otevřel celý odkaz z emailu.",
  NOT_FOUND:
    "Rezervaci se nepodařilo najít. Možná již byla zrušena nebo je odkaz neplatný.",
  EXPIRED:
    "Platnost potvrzovacího odkazu vypršela. Vytvoř prosím novou rezervaci.",
  SLOT_TAKEN:
    "Termín byl mezitím obsazen někým jiným. Vyber prosím jiný čas.",
  SERVER_ERROR:
    "Něco se pokazilo na naší straně. Zkus to prosím znovu nebo nás kontaktuj na 777 606 447.",
};

const ReservationDetails = ({ reservation }) => {
  const employee = getEmployee(parseInt(reservation.zamestnanecId, 10));
  const formattedDate = dayjs(reservation.datum).format("DD.MM.YYYY");
  const formattedTime = dayjs(reservation.zacatek_cas, "HH:mm:ss").format(
    "HH:mm",
  );

  return (
    <ul className="confirmDetailsList">
      <li>
        <span className="confirmDetailLabel">Barber:</span>
        <span className="confirmDetailValue">
          {employee ? employee.name : "—"}
        </span>
      </li>
      <li>
        <span className="confirmDetailLabel">Datum:</span>
        <span className="confirmDetailValue">{formattedDate}</span>
      </li>
      <li>
        <span className="confirmDetailLabel">Čas:</span>
        <span className="confirmDetailValue">{formattedTime}</span>
      </li>
      <li>
        <span className="confirmDetailLabel">Služba:</span>
        <span className="confirmDetailValue">{reservation.klient_sluzba}</span>
      </li>
      {reservation.klient_sluzby_dodatecne && (
        <li>
          <span className="confirmDetailLabel">Extra služby:</span>
          <span className="confirmDetailValue">
            {reservation.klient_sluzby_dodatecne}
          </span>
        </li>
      )}
      <li>
        <span className="confirmDetailLabel">Cena:</span>
        <span className="confirmDetailValue">
          {reservation.klient_cena} Kč
        </span>
      </li>
    </ul>
  );
};

export const ReservationConfirmed = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading"); // "loading" | "success" | "error"
  const [reservation, setReservation] = useState(null);
  const [errorCode, setErrorCode] = useState(null);

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setErrorCode("BAD_TOKEN");
      setStatus("error");
      return;
    }

    let cancelled = false;
    const confirm = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL_CONFIRM}?token=${encodeURIComponent(token)}`,
        );
        if (cancelled) return;
        if (response.data && response.data.success) {
          setReservation(response.data.reservation);
          setStatus("success");
        } else {
          setErrorCode((response.data && response.data.code) || "SERVER_ERROR");
          setStatus("error");
        }
      } catch (err) {
        if (cancelled) return;
        console.error("Confirm reservation failed:", err);
        setErrorCode("SERVER_ERROR");
        setStatus("error");
      }
    };

    confirm();
    return () => {
      cancelled = true;
    };
  }, [searchParams]);

  return (
    <div className="reservationConfirmed">
      <div className="pageWrapper">
        <Navbar />
        <div className="bodyContent">
          <div className="confirmCard">
            {status === "loading" && (
              <div className="confirmLoadingState">
                <div className="confirmSpinner" />
                <h2>Potvrzujeme tvoji rezervaci…</h2>
              </div>
            )}

            {status === "success" && reservation && (
              <div className="confirmSuccessState">
                <div className="confirmCheckIcon">✓</div>
                <h2>Rezervace potvrzena!</h2>
                <p className="confirmSubtitle">
                  Těšíme se na tvou návštěvu. Detaily jsme ti také poslali
                  na email.
                </p>
                <ReservationDetails reservation={reservation} />
                <Link to="/" className="confirmHomeBtn">
                  Zpět na úvod
                </Link>
              </div>
            )}

            {status === "error" && (
              <div className="confirmErrorState">
                <div className="confirmErrorIcon">!</div>
                <h2>Rezervaci se nepodařilo potvrdit</h2>
                <p className="confirmErrorMessage">
                  {ERROR_MESSAGES[errorCode] || ERROR_MESSAGES.SERVER_ERROR}
                </p>
                <Link to="/rezervace" className="confirmRetryBtn">
                  Vrátit se na rezervaci
                </Link>
              </div>
            )}
          </div>
        </div>
        <footer>
          <Footer />
        </footer>
      </div>
    </div>
  );
};
